<template>
  <p class="col-12" :class="sessionExpired ? 'text-danger' : 'text-muted'">
    {{ message }}
    <a v-if="sessionExpired" href="#" class="link-discount ml-2" @click.prevent="$emit('login-requested')">
      {{ texts.GO_TO_LOGIN }}
    </a>
  </p>
</template>

<script>
import { CONNECTION_NOTICE_TEXTS } from '../deliveryConstants'

const SEPARATOR = ' · '

export default {
  name: 'DeliveryConnectionNotice',
  props: {
    lastUpdate: {
      type: String,
      default: ''
    },
    sessionExpired: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    texts () {
      return CONNECTION_NOTICE_TEXTS
    },
    message () {
      if (this.sessionExpired) {
        return this.texts.SESSION_EXPIRED
      }
      const parts = [this.texts.CONNECTION_LOST]
      if (this.lastUpdate) {
        parts.push(`${this.texts.LAST_UPDATE} ${this.lastUpdate}`)
      }
      parts.push(this.texts.RETRYING)
      return parts.join(SEPARATOR)
    }
  }
}
</script>
